const modalLoaderFactory = context => {
  return {
    show () {
      context.$store.dispatch('showModalLoader')
    },
    hide () {
      context.$store.dispatch('hideModalLoader')
    }
  }
}

export default modalLoaderFactory



// WEBPACK FOOTER //
// ./src/plugins/modal-loader/factory.js